import { render, staticRenderFns } from "./IconCirculeDefendant.vue?vue&type=template&id=4ddb9611"
import script from "./IconCirculeDefendant.vue?vue&type=script&lang=js"
export * from "./IconCirculeDefendant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports